import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function AccessDenied() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="container-fluid d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <div className="text-center">
        {/* Lock Icon */}
        <div className="mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-secondary"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
        </div>

        {/* Title */}
        <h1 className="display-4 mb-3">{t('access_denied.title', 'Access Denied')}</h1>

        {/* Message */}
        <p className="lead text-muted mb-4">
          {t('access_denied.message', 'To receive access please contact your administrator.')}
          <br />
          {t('access_denied.admin_message', 'If you are the administrator, please contact support.')}
        </p>

        {/* Return Button */}
        <button
          className="btn btn-primary btn-lg"
          onClick={() => navigate('/dashboard')}
        >
          {t('access_denied.return_dashboard', 'Return to Dashboard')}
        </button>
      </div>
    </div>
  );
}
